{
  "cookies-dialog": {
    "buttons": {
      "accept-all": "Alle Cookies akzeptieren",
      "save": "Einstellung speichern",
      "setting": "Cookies einstellen"
    },
    "text": {
      "title": "Datenschutz & Cookies",
      "content-1": "Wir verwenden Analysemethoden (z.B. Cookies oder Fingerprints), um zu messen, wie häufig unsere Seite besucht und wie sie genutzt wird. Außerdem verwenden wir technische Drittinhalte zur vereinfachten Steuerung von Tags (Tagmanager).",
      "content-2": "Wir setzen in diesem Rahmen auch Dienstleister in Drittländern außerhalb der EU ohne angemessenes Datenschutzniveau ein, was folgende Risiken birgt: Zugriff durch Behörden ohne Information, keine Betroffenenrechte, keine Rechtsmittel, Kontrollverlust.",
      "content-3": "Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer Datenschutzerklärung. Mit Ihrer Einstellung willigen Sie in die oben beschriebenen Vorgänge ein.",
      "essential-cookies": "Essenziell",
      "essential-cookies-description": "Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.",
      "statistics-cookies": "Analyse & Statistiken",
      "statistics-cookies-description": "Analyse & Statistik Cookies erfassen Informationen anonym. Diese Informationen helfen uns zu verstehen, wie unsere Besucher unsere Website nutzen."
    }
  }
}
